import { marked } from 'marked';

export function setQuillContent(quillRef, markdown) {
	const html = marked.parse(markdown);
	const delta = quillRef.current.clipboard.convertHTML(html);
	quillRef.current.setContents(delta);
}
